export enum PermsSlugs {
  DASHBOARD = 'dashboard',
  SELLER = 'seller',
  PRODUCT = 'product',
  CUSTOMER = 'customer',
  REMINDER = 'reminder',
  FACTOR = 'factor',
  NOTE = 'note',
}

export const PhoneTypesIcons: {[key: string]: string} = {
  MOBILE: 'smartphone',
  PHONE: 'phone',
  WORK: 'sidebar',
  FAX: 'trello',
};

export const SocialsTypesIcons: {[key: string]: string} = {
  instagram: 'instagram',
  telegram: 'send',
  whatsapp: 'link',
  pinterest: 'link',
  twitter: 'twitter',
};
